import BaseMap from 'components/BaseMap/BaseMap';
import 'leaflet/dist/leaflet.css';
import { Circle, Polygon } from 'react-leaflet';

const AlertMap = ({ alert }) => {
  return (
    <div
      className="ratio rounded-3 overflow-hidden flex-shrink-0"
      style={{
        '--bs-aspect-ratio': '50%',
        width: 330,
        maxWidth: 330,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      {alert.processedCenter &&
        (alert.processedPolygon?.length || alert.processedCircles?.length) && (
          <BaseMap
            mapCenter={alert.processedCenter}
            scrollZoom={false}
            zoom={11}
            disableMapReset={true}
            bounds={alert.processedBounds ?? alert.processedPolygon}
            mapViewHideLabelsToggle={true}
            disableMapControls={true}
            style={{ zIndex: 0 }}
          >
            {alert.processedPolygon?.map((poly, index) => (
              <Polygon key={`polygon-${index}`} positions={poly} />
            ))}
            {alert.processedCircles?.map((circle, index) => (
              <Circle key={`circle-${index}`} center={circle.center} radius={circle.radius} />
            ))}
          </BaseMap>
        )}
    </div>
  );
};

export default AlertMap;
